import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import styles from './BetterButton.module.scss';

export default function BetterButton({ type = 'primary', size, htmlType, to, href, onClick, disabled, loading, iconLeft, iconRight, children, style, className }) {
    const typeClass =
        type === 'danger'   ? styles.danger   :
        type === 'secondary' ? styles.secondary :
        type === 'outlined'  ? styles.outlined  :
        styles.primary;
    const sizeClass = size === 'sm' ? styles.sm : '';

    const content = loading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
    ) : (
        <>
            {iconLeft && <FontAwesomeIcon icon={iconLeft} className={styles.iconStyle} />}
            {children}
            {iconRight && <FontAwesomeIcon icon={iconRight} className={styles.iconStyle} />}
        </>
    );

    const cls = [styles.button, typeClass, sizeClass, className].filter(Boolean).join(' ');

    if (to) {
        return (
            <Link to={to} className={cls} style={style}>
                {content}
            </Link>
        );
    }

    if (href) {
        return (
            <a href={href} className={cls} style={style} target="_blank" rel="noreferrer">
                {content}
            </a>
        );
    }

    return (
        <button
            className={cls}
            style={{ ...(disabled ? { cursor: 'not-allowed', opacity: 0.4 } : {}), ...style }}
            onClick={onClick}
            disabled={disabled}
            type={htmlType || 'button'}
        >
            {content}
        </button>
    );
}
